/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {Dropdown1} from '../../../../_metronic/partials'
import {useLocation} from 'react-router'
import {useEffect, useState} from 'react'
import {ProfileDetails2} from '../components/Edit'
import {Detail} from '../components/Detail'

import axios from 'axios'

export function EditParticipant(props: any) {
  const API_URL = process.env.REACT_APP_API_URL
  const location = useLocation()
  const [user, setUser] = useState<any>([
    {
      email: '-',
      mobile_number: '-',
      participantsMasters: null,
      id: '',
      code: ''
    },
  ])
  const [overviewTab, setOveriewTab] = useState<any>('active')
  const [settingTab, setSettingTab] = useState<any>('')
  const [data, setData] = useState<any>({
    burnEarnPurchase: {
      earn: 0,
      burn: 0,
      purchase: 0
    },
    redeemHistory: [],
    transaction: [],
  })
  const getAPI = async () => {
    console.log(location)
    setUser(location.state)
    let text:any = location.state
    const data = await axios.get(`${API_URL}/fixedDashBoard/participant/${text.id}`).then((res) => {
      setData(() => res.data.data)
    })
    //return data.data.data
  }
  useEffect(
    () => {
      getAPI()
    },
    [] // Only re-call effect if value or delay changes
  )
  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                <img src={user.image} alt='user_pic' />
                {/*<div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px'></div>*/}
              </div>
            </div>

            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='d-flex align-items-center mb-2'>
                    <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                      {user.firstname} {user.lastname}
                    </a>
                    {/*<a href='#'>
                    <KTIcon iconName='verify' className='fs-1 text-primary' />
                  </a>
                  <a
                    href='#'
                    className='btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_upgrade_plan'
                  >
                    Upgrade to Pro
                  </a>*/}
                  </div>

                  <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                    {/*<a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTIcon iconName='profile-circle' className='fs-4 me-1' />
                    Developer
                  </a>*/}
                    {/*<a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTIcon iconName='geolocation' className='fs-4 me-1' />
                    SF, Bay Area
                  </a>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'
                  >
                    <KTIcon iconName='sms' className='fs-4 me-1' />
                    max@kt.com
                  </a>*/}
                  </div>
                </div>

                {/*<div className='d-flex my-4'>
                <a href='#' className='btn btn-sm btn-light me-2' id='kt_user_follow_button'>
                  <KTIcon iconName='check' className='fs-3 d-none' />

                  <span className='indicator-label'>Follow</span>
                  <span className='indicator-progress'>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                </a>
                <a
                  href='#'
                  className='btn btn-sm btn-primary me-3'
                  data-bs-toggle='modal'
                  data-bs-target='#kt_modal_offer_a_deal'
                >
                  Hire Me
                </a>
                <div className='me-0'>
                  <button
                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                    data-kt-menu-trigger='click'
                    data-kt-menu-placement='bottom-end'
                    data-kt-menu-flip='top-end'
                  >
                    <i className='bi bi-three-dots fs-3'></i>
                  </button>
                  <Dropdown1 />
                </div>
              </div>*/}
              </div>

              <div className='d-flex flex-wrap flex-stack'>
                <div className='d-flex flex-column flex-grow-1 pe-8'>
                  <div className='d-flex flex-wrap'>
                    <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                      <div className='d-flex align-items-center'>
                        {/*<KTIcon iconName='arrow-up' className='fs-3 text-success me-2' />*/}
                        <div className='fs-2 fw-bolder'>อีเมล</div>
                      </div>

                      <div className='fw-bold fs-6 text-gray-400'>
                        {user.email ? user.email : '-'}
                      </div>
                    </div>

                    <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                      <div className='d-flex align-items-center'>
                        {/*<KTIcon iconName='arrow-down' className='fs-3 text-danger me-2' />*/}
                        <div className='fs-2 fw-bolder'>เบอร์โทรศัพท์</div>
                      </div>

                      <div className='fw-bold fs-6 text-gray-600'>
                        {user.mobile_number ? user.mobile_number : '-'}
                      </div>
                    </div>

                    <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                      <div className='d-flex align-items-center'>
                        {/*<KTIcon iconName='arrow-up' className='fs-3 text-success me-2' />*/}
                        <div className='fs-2 fw-bolder'>ที่อยู่</div>
                      </div>

                      <div className='fw-bold fs-6 text-gray-600'>
                        {user.participantsMasters ? user.participantsMasters[0].address : '-'}
                      </div>
                    </div>
                  </div>
                </div>

                {/*<div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
                <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                  <span className='fw-bold fs-6 text-gray-400'>อีกกี่คะแนน</span>
                  <span className='fw-bolder fs-6'>50%</span>
                </div>
                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                  <div
                    className='bg-success rounded h-5px'
                    role='progressbar'
                    style={{width: '50%'}}
                  ></div>
                </div>
              </div>*/}
              </div>
            </div>
          </div>

          <div className='d-flex overflow-auto h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              <li
                className='nav-item'
                onClick={() => {
                  setOveriewTab('active')
                  setSettingTab('')
                }}
              >
                <span
                  className={`nav-link text-active-primary me-6 ` + overviewTab}
                  //to='/crafted/account/overview'
                >
                  Overview
                </span>
              </li>
              <li
                className='nav-item'
                onClick={() => {
                  setSettingTab('active')
                  setOveriewTab('')
                }}
              >
                <span
                  className={`nav-link text-active-primary me-6 ` + settingTab}
                  //to='/crafted/account/settings'
                >
                  Settings
                </span>
              </li>
            </ul>
          </div>
        </div>
        {settingTab ? <ProfileDetails2 {...user} /> : <Detail props={data} />}
      </div>
    </>
  )
}
